var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22220(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22220",
    "data-name": "Group 22220",
    transform: "translate(-252 -680)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5785",
    "data-name": "Rectangle 5785",
    width: 44,
    height: 44,
    rx: 5,
    transform: "translate(252 680)",
    fill: "#efebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8530643_building_icon",
    "data-name": "8530643_building_icon",
    d: "M6.6,7.631V5.568a.621.621,0,0,1,.619-.619H9.281a.621.621,0,0,1,.619.619V7.631a.621.621,0,0,1-.619.619H7.218A.621.621,0,0,1,6.6,7.631Zm7.218.619H15.88a.621.621,0,0,0,.619-.619V5.568a.621.621,0,0,0-.619-.619H13.818a.621.621,0,0,0-.619.619V7.631A.621.621,0,0,0,13.818,8.25Zm-6.6,4.95H9.281a.621.621,0,0,0,.619-.619V10.518A.621.621,0,0,0,9.281,9.9H7.218a.621.621,0,0,0-.619.619v2.062A.621.621,0,0,0,7.218,13.2Zm6.6,0H15.88a.621.621,0,0,0,.619-.619V10.518A.621.621,0,0,0,15.88,9.9H13.818a.621.621,0,0,0-.619.619v2.062A.621.621,0,0,0,13.818,13.2ZM9.9,17.53V15.468a.621.621,0,0,0-.619-.619H7.218a.621.621,0,0,0-.619.619V17.53a.621.621,0,0,0,.619.619H9.281A.621.621,0,0,0,9.9,17.53Zm3.919.619H15.88a.621.621,0,0,0,.619-.619V15.468a.621.621,0,0,0-.619-.619H13.818a.621.621,0,0,0-.619.619V17.53A.621.621,0,0,0,13.818,18.149ZM23.1,24.542V26.4H0V24.542a.621.621,0,0,1,.619-.619H1.624V1.237A1.234,1.234,0,0,1,2.862,0H20.237a1.234,1.234,0,0,1,1.237,1.237V23.924H22.48A.621.621,0,0,1,23.1,24.542Zm-19-.67H9.9V20.418a.621.621,0,0,1,.619-.619h2.062a.621.621,0,0,1,.619.619v3.454H19V2.526L4.125,2.475Z",
    transform: "translate(262.288 688.801)",
    fill: "#6d4eec",
    stroke: "#efebff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22220);
export default __webpack_public_path__ + "static/media/Group 22220.52eceff793922af3a2aca90f71445e43.svg";
export { ForwardRef as ReactComponent };